var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Box from '@mui/material/Box';
import React, { useState } from 'react';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DeleteIcon from '@mui/icons-material/Delete';
import dateTimeUtils, { calculateDaysSince } from '../../../utils/DateTimeUtils';
import { Button, Grid, IconButton, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useSelector } from 'react-redux';
const START = dateTimeUtils(0).startOf('year');
const storageKey = 'boushar.counters';
export default function () {
    const { showResetButton } = useSelector((state) => state.countersSettings);
    // TODO remove counters an otherCounters from state and use data directly
    const [counters, setCounters] = React.useState({});
    const [data, setData] = useState({ version: 1, counters: {}, otherCounters: {} });
    const [value, setValue] = useState('');
    const [errorState, setErrorState] = useState(false);
    React.useEffect(() => {
        const fetchData = async () => {
            const data = await readData();
            if (data) {
                setData(data);
                setCounters(data.counters);
            }
        };
        fetchData();
    }, []);
    const handleInputChange = (e) => {
        var _a;
        setValue((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        if (e.target.value.trim() === '') {
            setErrorState(true);
        }
        else {
            setErrorState(false);
        }
    };
    const addCounter = () => {
        if (value !== '') {
            const counterName = value;
            if (!counters.hasOwnProperty(counterName)) {
                setCounters(Object.assign(Object.assign({}, counters), { [counterName]: 0 }));
                saveData(Object.assign(Object.assign({}, data), { counters: Object.assign(Object.assign({}, counters), { [counterName]: 0 }) }));
            }
            setValue('');
        }
    };
    const deleteCounter = (counterName) => {
        const _a = counters, _b = counterName, _ = _a[_b], remainingCounters = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]); // Remove the counter
        setCounters(remainingCounters);
        saveData(Object.assign(Object.assign({}, data), { counters: remainingCounters })); // Save updated data
    };
    // Other Counters logic
    const [otherCounterName, setOtherCounterName] = useState('');
    const [otherCounterError, setOtherCounterError] = useState(false);
    const addOtherCounter = () => {
        if (otherCounterName.trim() === '') {
            setOtherCounterError(true);
            return;
        }
        if (!data.otherCounters.hasOwnProperty(otherCounterName)) {
            const newOtherCounters = Object.assign(Object.assign({}, data.otherCounters), { [otherCounterName]: 0 });
            setData(Object.assign(Object.assign({}, data), { otherCounters: newOtherCounters }));
            saveData(Object.assign(Object.assign({}, data), { otherCounters: newOtherCounters }));
        }
        setOtherCounterName('');
        setOtherCounterError(false);
    };
    const deleteOtherCounter = (name) => {
        const _a = data.otherCounters, _b = name, _ = _a[_b], remaining = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        setData(Object.assign(Object.assign({}, data), { otherCounters: remaining }));
        saveData(Object.assign(Object.assign({}, data), { otherCounters: remaining }));
    };
    const incrementOtherCounter = (name) => {
        const value = data.otherCounters[name] || 0;
        const newOtherCounters = Object.assign(Object.assign({}, data.otherCounters), { [name]: value + 1 });
        setData(Object.assign(Object.assign({}, data), { otherCounters: newOtherCounters }));
        saveData(Object.assign(Object.assign({}, data), { otherCounters: newOtherCounters }));
    };
    const decrementOtherCounter = (name) => {
        const value = data.otherCounters[name] || 0;
        const newOtherCounters = Object.assign(Object.assign({}, data.otherCounters), { [name]: value - 1 });
        setData(Object.assign(Object.assign({}, data), { otherCounters: newOtherCounters }));
        saveData(Object.assign(Object.assign({}, data), { otherCounters: newOtherCounters }));
    };
    const handleReset = () => {
        setCounters(prev => {
            // Create a new object where every key from the old counters is now 0
            const resetCounters = Object.keys(prev).reduce((acc, key) => {
                acc[key] = calculateDaysSince(START.format('YYYY-MM-DD'));
                return acc;
            }, {});
            return Object.assign({}, resetCounters);
        });
    };
    return (React.createElement(Box, { sx: { maxWidth: 600, margin: '0 auto', p: 2 } },
        React.createElement(Box, { sx: { mb: 4 } },
            React.createElement("h1", null,
                "Daily Counters ",
                showResetButton && (React.createElement(Button, { variant: "contained", onClick: handleReset }, "Reset"))),
            React.createElement(Grid, { container: true, spacing: 1, alignItems: "center" },
                React.createElement(Grid, { item: true, xs: 9, sm: 10 },
                    React.createElement(TextField, { label: "Counter name", value: value, onChange: handleInputChange, error: errorState, helperText: errorState ? "Please enter some text" : "", fullWidth: true, size: "small" })),
                React.createElement(Grid, { item: true, xs: 3, sm: 2 },
                    React.createElement(IconButton, { color: "primary", onClick: addCounter, sx: { p: 1.5 } },
                        React.createElement(AddIcon, null)))),
            React.createElement(Box, { sx: { mt: 2 } }, Object.entries(counters)
                .sort(([, a], [, b]) => {
                if (a === 0)
                    return 1; // Move 0 to the end
                if (b === 0)
                    return -1; // Move 0 to the end
                return b - a; // Sort descending
            })
                .map(([name, value]) => (React.createElement(Grid, { container: true, spacing: 1, alignItems: "center", key: name, sx: { mb: 1, p: 1, borderRadius: 1, bgcolor: 'action.hover' } },
                React.createElement(Grid, { item: true, xs: 5, sm: 6, sx: { fontWeight: 500 } }, name),
                React.createElement(Grid, { item: true, xs: 3, sm: 2 }, calculateDaysSince(START.format('YYYY-MM-DD')) - value),
                React.createElement(Grid, { item: true, xs: 2, sm: 2 },
                    React.createElement(IconButton, { color: "primary", onClick: () => {
                            const newCounters = Object.assign(Object.assign({}, counters), { [name]: value + 1 });
                            setCounters(newCounters);
                            setData(Object.assign(Object.assign({}, data), { counters: newCounters }));
                            saveData(Object.assign(Object.assign({}, data), { counters: newCounters }));
                        } },
                        React.createElement(RemoveIcon, null))),
                React.createElement(Grid, { item: true, xs: 2, sm: 2 },
                    React.createElement(IconButton, { color: "error", onClick: () => deleteCounter(name) },
                        React.createElement(DeleteIcon, null)))))))),
        React.createElement(Box, { sx: { mb: 4 } },
            React.createElement("h1", null, "Other Counters"),
            React.createElement(Grid, { container: true, spacing: 1, alignItems: "center", sx: { mb: 2 } },
                React.createElement(Grid, { item: true, xs: 9, sm: 10 },
                    React.createElement(TextField, { label: "Other counter name", value: otherCounterName, onChange: e => setOtherCounterName(e.target.value), error: otherCounterError, helperText: otherCounterError ? "Please enter some text" : "", fullWidth: true, size: "small" })),
                React.createElement(Grid, { item: true, xs: 3, sm: 2 },
                    React.createElement(IconButton, { color: "primary", onClick: addOtherCounter, sx: { p: 1.5 } },
                        React.createElement(AddIcon, null)))),
            React.createElement(Box, null, Object.entries(data.otherCounters)
                .map(([name, value]) => (React.createElement(Grid, { container: true, spacing: 1, alignItems: "center", key: name, sx: { mb: 1, p: 1, borderRadius: 1, bgcolor: 'action.hover' } },
                React.createElement(Grid, { item: true, xs: 5, sm: 6, sx: { fontWeight: 500 } }, name),
                React.createElement(Grid, { item: true, xs: 3, sm: 2 }, value),
                React.createElement(Grid, { item: true, xs: 2, sm: 2 },
                    React.createElement(IconButton, { color: "primary", onClick: () => incrementOtherCounter(name) },
                        React.createElement(ArrowDropUpIcon, null)),
                    React.createElement(IconButton, { color: "primary", onClick: () => decrementOtherCounter(name) },
                        React.createElement(ArrowDropDownIcon, null))),
                React.createElement(Grid, { item: true, xs: 2, sm: 2 },
                    React.createElement(IconButton, { color: "error", onClick: () => deleteOtherCounter(name) },
                        React.createElement(DeleteIcon, null))))))))));
}
const BARAM = 'boushar.baram';
const readData = async () => {
    var _a, _b;
    const sLocalData = localStorage.getItem(storageKey);
    let localData = null;
    if (sLocalData != null) {
        localData = upgradeData(sLocalData);
    }
    const secretKey = localStorage.getItem(BARAM);
    try {
        if (secretKey !== null) {
            const response = await fetch("api/storage", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-BOUSHAR-BARAM": secretKey
                }
            });
            if (response.status === 200) {
                let serverData = await response.json();
                serverData = upgradeData(serverData);
                // Compare updatedTimestamp fields
                const serverTimestamp = (_a = serverData.updatedTimestamp) !== null && _a !== void 0 ? _a : 0;
                const localTimestamp = (_b = localData === null || localData === void 0 ? void 0 : localData.updatedTimestamp) !== null && _b !== void 0 ? _b : 0;
                if (serverTimestamp > localTimestamp) {
                    // Server is newer, replace local
                    localStorage.setItem(storageKey, JSON.stringify(serverData));
                    return serverData;
                }
                else if (localData != null) {
                    // Local is newer or equal, keep local
                    return localData;
                }
                return serverData;
            }
        }
    }
    catch (error) {
        console.error("Error fetching data from server:", error);
    }
    return localData;
};
const upgradeData = (sData) => {
    if (sData != null) {
        let data = sData;
        if (typeof sData === 'string') {
            data = JSON.parse(sData);
        }
        if (!data.hasOwnProperty('version')) {
            const counters = data;
            const otherCounters = {};
            return { version: 1, counters, otherCounters };
        }
        else if (data.version === 1) {
            return data;
        }
    }
    return null;
};
const saveData = (data) => {
    const newData = Object.assign(Object.assign({}, data), { updatedTimestamp: Date.now() });
    localStorage.setItem(storageKey, JSON.stringify(newData));
    // Also send to server if needed
    const secretKey = localStorage.getItem(BARAM);
    if (secretKey !== null) {
        fetch("api/storage", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-BOUSHAR-BARAM": secretKey
            },
            body: JSON.stringify(newData)
        });
    }
};
